import React from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import BusinessMetrics from "../../public/img/business-metrics-health.png"
import Growth from "../../public/img/growth-ai.png"
import SpreadSheet from "../../public/img/spreadsheet.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import NextLink from "next/link"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import { suppliersFaq } from "../../data/SuppliersFaq"

export default function Suppliers() {

  const textColor = useColorModeValue("gray.500", "white")
  function ButtonClick() {
  }
  return (
    <>
      <Meta
        pageName={"Monitor Amazon Sellers You Sell To - TrackSellers"}
        description={"Monitor the health of Amazon sellers business that you sell to. Find more Amazon sellers with us to market your products & grow your business."}
        hrefLink={"https://www.tracksellers.com/suppliers"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                The Ultimate Solution for Finding Manufacturers, Suppliers & Distributors on Amazon
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Maximize sales, strengthen customer relationships, and stay ahead of the competition in the Amazon marketplace
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={BusinessMetrics}
                    alt="BusinessMetrics"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Gain Comprehensive Insights into Amazon Sellers
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Access in-depth information on over 5 million Amazon sellers, including sales, revenue, order volume, ratings, and reviews.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Understand your share of wallet and identify areas for potential growth within your customers&apos; businesses.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Monitor customers&apos; performance to reduce payment risk, ensuring you make informed decisions about credit and payment terms.
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Identify Competitors and Uncover New Opportunities
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Discover sellers competing in the same categories with similar sales volume, allowing you to identify areas for market expansion.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Leverage our Advanced Seller Search to find potential leads by filtering through multiple criteria, increasing your customer base.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Stay informed on market trends, helping you adapt your strategies and outperform competitors in the ever-evolving e-commerce landscape.
                    </Text>
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Growth}
                    alt="Growth"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={SpreadSheet}
                    alt="SpreadSheet"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Streamline Amazon Sellers Lead Generation and Customer Acquisition
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Use TrackSellers&apos; powerful search features and vast dataset to efficiently generate targeted lead lists tailored to your business needs.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Easily integrate the data into your favorite CRM system, streamlining your sales and marketing efforts.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Save time and effort with our user-friendly platform, allowing you to focus on growing your business and fostering customer relationships.
                    </Text>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Are you ready to supercharge your sales and stay ahead of the competition?
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Sign up for TrackSellers today and unlock the full potential of our comprehensive platform designed for manufacturers, suppliers, and distributors.
          </Text>
          <NextLink href={"/get-started"} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                suppliersFaq?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}